import React, { useState } from 'react';
import { ArrowUpRight, Menu, Search, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = React.useRef(null);
  const toggleRef = React.useRef(null);

  const toggleMenu = () => setIsMenuOpen((value) => !value);

  React.useEffect(() => {
    if (!isMenuOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
        toggleRef.current?.focus();
      }
      if (event.key === 'Tab' && menuRef.current) {
        const focusables = menuRef.current.querySelectorAll('a[href], button');
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';
    menuRef.current?.querySelector('a[href], button')?.focus();
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header className="site-header sticky top-0 z-50">
      <div className="container-max">
        <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
          <a href="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity">
            <div className="site-mark">
              <Search className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="text-base font-bold text-slate-900 leading-none">Free SERP Checker</p>
              <p className="text-[11px] text-slate-500 mt-1 leading-none">Google search results</p>
            </div>
          </a>

          <nav className="hidden md:flex items-center gap-7">
            <a href="/google-location-changer/" className="text-sm text-slate-600 hover:text-brand-600 transition-colors font-medium">Location Changer</a>
            <a href="/how-to-use/" className="text-sm text-slate-600 hover:text-brand-600 transition-colors font-medium">How to Use</a>
            <a href="/features/" className="text-sm text-slate-600 hover:text-brand-600 transition-colors font-medium">Features</a>
            <a href="/faq/" className="text-sm text-slate-600 hover:text-brand-600 transition-colors font-medium">FAQ</a>
            <a href="/#serp-checker" className="header-cta">
              Check SERP <ArrowUpRight aria-hidden="true" className="w-4 h-4" />
            </a>
          </nav>

          <button
            ref={toggleRef}
            onClick={toggleMenu}
            className="md:hidden inline-flex items-center justify-center min-h-[44px] min-w-[44px] rounded-md hover:bg-slate-100 transition-colors"
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
            aria-controls="mobile-nav"
          >
            {isMenuOpen ? <X className="w-6 h-6 text-slate-700" /> : <Menu className="w-6 h-6 text-slate-700" />}
          </button>
        </div>

        {isMenuOpen && (
          <div id="mobile-nav" ref={menuRef} className="md:hidden py-3 border-t border-slate-200 px-4 sm:px-6">
            <nav className="flex flex-col">
              <a href="/google-location-changer/" className="min-h-[44px] flex items-center text-slate-700 hover:text-brand-600 transition-colors font-medium" onClick={() => setIsMenuOpen(false)}>Location Changer</a>
              <a href="/how-to-use/" className="min-h-[44px] flex items-center text-slate-700 hover:text-brand-600 transition-colors font-medium" onClick={() => setIsMenuOpen(false)}>How to Use</a>
              <a href="/features/" className="min-h-[44px] flex items-center text-slate-700 hover:text-brand-600 transition-colors font-medium" onClick={() => setIsMenuOpen(false)}>Features</a>
              <a href="/faq/" className="min-h-[44px] flex items-center text-slate-700 hover:text-brand-600 transition-colors font-medium" onClick={() => setIsMenuOpen(false)}>FAQ</a>
              <a href="/#serp-checker" className="min-h-[44px] flex items-center text-brand-600 font-semibold" onClick={() => setIsMenuOpen(false)}>Check SERP</a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
